import { type QueryClient, useQuery } from '@tanstack/react-query';
import { reportingStoreQueryKeys } from '@/common/api/reporting-store/queryKeys';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { useOrgId } from '@/common/hooks/useOrgId';
import { HealthApi } from '@/features/insights-dashboard/api/health';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';

export const invalidateHealthSummary = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: reportingStoreQueryKeys.health.all() });
};

export const useHealthSummary = ({
  filters,
  scopeItemId,
  loopId,
  enabled = true,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  enabled?: boolean;
}) => {
  const orgId = useOrgId();

  return useQuery({
    queryKey: reportingStoreQueryKeys.health.summary({ filters, scopeItemId, loopId, orgId }),
    queryFn: () => HealthApi.getHealthSummary({ filters, scopeItemId, loopId }),
    enabled,
    staleTime: INSIGHTS_STALE_TIME,
    placeholderData: (previousData) => previousData,
    retry: false,
  });
};
